import styled from '@emotion/styled';
import useWindowSize from 'hooks/useWindowSize';
import React, { useEffect, useRef, useState } from 'react';

export default function ReadmoreHomeContent({ children }) {
    const { width } = useWindowSize();
    const refs = useRef(null) as any;
    const contentRef = useRef(null) as any;
    const [isMoreContent, setIsMoreContent] = useState(true);

    const onReadMore = () => {
        setIsMoreContent(false);
        refs.current.style.height = 'auto';
    };

    useEffect(() => {
        const checkContentHeight = () => {
            if (contentRef.current && contentRef.current.clientHeight > 650 && width < 576) {
                setIsMoreContent(true);
                // refs.current.style.height = '650px';
            } else if (contentRef.current && contentRef.current.clientHeight > 850) {
                setIsMoreContent(true);
                // refs.current.style.height = '850px';
            } else {
                refs.current.style.height = '150px';
            }
        };

        // checkContentHeight();
    }, [children]);

    return (
        <Style ref={refs}>
            <div className='readmore-content' ref={contentRef}>
                {children}
            </div>
            {isMoreContent && (
                <div className='read-more'>
                    <span onClick={onReadMore}>อ่านต่อ</span>
                </div>
            )}
        </Style>
    );
}

const Style = styled.div`
    label: readmore-home-content;

    position: relative;
    width: 100%;
    height: 170px;
    overflow: hidden;

    .readmore-content {
        position: relative;
        z-index: 1;
    }
    .read-more {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 177px;
        /* height: 250px; */
        z-index: 2;
        background-image: linear-gradient(to bottom, transparent 0%, #ffffff 50%);

        span {
            color: var(--second-color);
            font-weight: 500;
            cursor: pointer;
        }
    }
`;
